var _style, _g, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComputer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#0DD0C4;}\n\t.st1{fill:#02BAA8;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M236.8,197.8L283.1,16H0v360h191.3l36.9-144.7C200.6,242.4,181,269.5,181,301v15h-30v-15 C151,249.7,188,206.8,236.8,197.8z M144.8,163.4l-21.2-21.2l21.2-21.2l-21.2-21.2l21.2-21.2L166,99.8l21.2-21.2l21.2,21.2 L187.2,121l21.2,21.2l-21.2,21.2L166,142.2L144.8,163.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M391,496v-30h-63.3l-15-60H199.3l-15,60H121v30C125.6,496,394,496,391,496z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M283.1,16l-46.4,181.8c6.2-1.2,12.7-1.8,19.2-1.8c57.9,0,105,47.1,105,105v15h-30v-15c0-41.3-33.7-75-75-75 c-9.8,0-19.2,1.9-27.8,5.3L191.3,376H512V16H283.1z M388.4,142.2l-21.2,21.2L346,142.2l-21.2,21.2l-21.2-21.2l21.2-21.2l-21.2-21.2 l21.2-21.2L346,99.8l21.2-21.2l21.2,21.2L367.2,121L388.4,142.2z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComputer);
export default __webpack_public_path__ + "static/media/computer.13352b5814c5ba2772c01164f47aaad6.svg";
export { ForwardRef as ReactComponent };